var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseClean(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2018_16249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2 4.30518C11.94 4.04518 11.52 4.04518 11.26 4.30518L7.99998 7.55852L4.73998 4.29852C4.47998 4.03852 4.05998 4.03852 3.79998 4.29852C3.53998 4.55852 3.53998 4.97852 3.79998 5.23852L7.05998 8.49852L3.79998 11.7585C3.53998 12.0185 3.53998 12.4385 3.79998 12.6985C4.05998 12.9585 4.47998 12.9585 4.73998 12.6985L7.99998 9.43852L11.26 12.6985C11.52 12.9585 11.94 12.9585 12.2 12.6985C12.46 12.4385 12.46 12.0185 12.2 11.7585L8.93998 8.49852L12.2 5.23852C12.4533 4.98518 12.4533 4.55852 12.2 4.30518Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2018_16249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.498535)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseClean);
export default __webpack_public_path__ + "static/media/close_clean.459d7767f9e90c46686dbe235d52e146.svg";
export { ForwardRef as ReactComponent };